import OccupancyCountsAttributeRenderer from './OccupancyCountsAttributeRenderer'
import ProductEventLocationCellRenderer from './ProductEventLocationCellRenderer'
import ProductEventSubtypeCellRenderer from './ProductEventSubtypeCellRenderer'

export default {
  install( molten ) {
    molten.addPlugin( 'AttributeValueRenderer', OccupancyCountsAttributeRenderer )
    molten.addPlugin( 'AttributeCellRenderer', ProductEventSubtypeCellRenderer )
    molten.addPlugin( 'AttributeCellRenderer', ProductEventLocationCellRenderer )
  } 
}
